import 
    {   basicProps } from './properties'

export const setArticleProfileInfo = (state, payload) => {

    state.props.id = payload.id
    state.props.article_title = payload.article_title
    state.props.wrrite_by_name = payload.wrrite_by_name
    state.props.wrrite_by_profile_link = payload.wrrite_by_profile_link
    state.props.article_content = payload.article_content
    
}

export const setArticleList = (state, payload) => {

    state.list = payload
}

export const resetArticleProfile = state => {
    state.props = JSON.parse(JSON.stringify(basicProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/articles/mutations.js